import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {ServiceRequest} from '../types/models';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {Attachment} from '../types/email-data.types';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {ResidentService} from './resident.service';
import {AuthenticationService} from './authentication.service';
import {Subscription} from 'rxjs/Subscription';
import {ServiceRequestStatus} from '../types/api-response/service-request/service-request-status';
import {filter, finalize, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

export enum ServiceRequestAction {
    commentRead = 'comment-read',
    commentCreate = 'comment-create',
    commentAttachment = 'comment-attachment',
    requestCreate = 'request-create',
    requestAttachment = 'request-attachment',
}

declare const toastr: any;
declare const $: any;

@Injectable()
export class ServiceRequestService {

    isServiceRequestModalShow = false;
    showDetailedView = false;
    showAddCommentModal = false;
    showAssignToModal = false;
    isViewAttachmentModalShow = false;
    firstTimeLoading = true;
    selectedItemData: any;
    statusForChange: ServiceRequestStatus = null;
    isReadStatusForChange = -1;
    serviceRequestInServiceRequestModal: ServiceRequest;

    data = {
        allServiceRequests: {
            get: `/v1/service_request?expand=building,suite,resident,createdBy,serviceRequestType,serviceRequestWorkerContract,attachments`,
            data: [],
            total: null
        },
    };
    tabId = 'allServiceRequests';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    activities: HistoryItem[];
    detailsViewSpinnerShow = false;
    modalSpinnerShow = false;
    attachmentsToDisplay: Array<any> = [];
    serviceName: string = 'service_request';
    isCommentsLoading = false;
    requestTypesForDetailedView: Array<any> = [];
    requestTypesForDetailedViewSubscription = new Subscription;

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public residentService: ResidentService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService,
                private authenticationService: AuthenticationService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData(scrollToTop?) {
        this.getDataByQueryParams(scrollToTop).subscribe();
    }

    getDataByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        let defaultStatus = this.urlService.queryParams['status'];
        if (!defaultStatus && this.firstTimeLoading) {
            defaultStatus = '';
            defaultStatus += 'open,';
            defaultStatus += 'in_progress,';
            defaultStatus += 'on_hold,';
            this.urlService.queryParams['status'] = defaultStatus.slice(0, -1);
        }
        this.firstTimeLoading = false;
        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        let sortedByBuilding = '';
        if (this.authenticationService.userIsResident && selectedBuilding) {
            sortedByBuilding = `&building_id=${selectedBuilding.buildingId}&suite_id=${selectedBuilding.suite_id}`;
        }
        return this.api.getJson('domainServiceRequest', `${url}${queryParams}${selectedBuilding ? sortedByBuilding : ''}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity((entity: any) => {
                    if (entity.building && entity.building.bdId) {
                        entity.building.id = entity.building.bdId;
                    }
                    return ServiceRequest.fromExistingData(this.account.addPermissionsToEntity(entity, this.serviceName));
                }),
                tap(({finished}) => this.spinnerShow = !finished),
                tap(body => {
                    this.data[tabId].data = body.entities;
                    this.data[tabId].total = body.total;
                }),
                tap(() => {
                    if (scrollToTop && $('.table')[0]) {
                        $('.table')[0].scrollIntoView();
                    }
                }),
                filter(({finished}) => finished),
                tap(
                    () => {
                        if (this.selectedItemData) {
                            this.selectedItemData = this.data[tabId].data.find(si => si.id == this.selectedItemData.id);
                            if (this.selectedItemData) {
                                this.selectedItemData.checked = true;
                                this.convertSelectedItemAttachmentsLayout(this.selectedItemData);
                                this.getRequestComments(this.selectedItemData.id);
                            }
                        }
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get Service Requests');
                    }
                ),
                finalize(
                    () => {
                        this.emptyRowService.fillEmptyRow();
                    }
                )
            );
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?order-by=name|asc&expand=timeZone`;
        this.api.getInfiniteList('domainBD', url, 1000).subscribe(
            (res) => {
                this.buildings = res.entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    toggleDetailedView(data, state: boolean): void {
        if (!data)
            this.selectedItemData.checked = false;
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            if (this.selectedItemData.serviceRequestTypeOther)
                this.selectedItemData.serviceRequestType = {id: '0'};
            this.convertSelectedItemAttachmentsLayout(data);
            this.getActivity();
            for (const field in this.selectedItemData.formFields)
                this.selectedItemData.formFields[field].editMode = false;
            this.getRequestComments(this.selectedItemData.id);
            this.getRequestTypesForDetailedView(this.selectedItemData.buildingId);
        }
    }

    getActivity() {
        if (this.selectedItemData) {
            const url = `/v1/history.json?per-page=10000&order-by=loggedAt|desc&serviceRequest=${this.selectedItemData.id}`;
            this.api.get('domainServiceRequest', url).subscribe(
                res => this.activities = res.json().map(a => new HistoryItem(a)),
                error => this.api.errorHandler(error, 'Failed get Service Request activity log'),
                () => this.spinnerShow = false
            );
        }
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }

    convertSelectedItemAttachmentsLayout(data) {
        let tempArray: Array<any> = [];
        let realIndex = 1;
        this.selectedItemData.attachmentsToDisplay = [];
        for (let i = 0; i < data.attachments.length; i++) {
            tempArray.push(data.attachments[i]);
            if (realIndex % 3 == 0) {
                this.selectedItemData.attachmentsToDisplay.push(tempArray);
                tempArray = [];
            }
            if (i == data.attachments.length - 1 && tempArray.length)
                this.selectedItemData.attachmentsToDisplay.push(tempArray);
            realIndex++;
        }
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    getRequestComments(id) {
        this.isCommentsLoading = true;
        const url = `/v1/service_request_comments.json?expand=user&request_id=${id}`;
        this.api.get('domainServiceRequest', url).subscribe(
            res => this.selectedItemData.comments = JSON.parse(res._body).entities || [],
            error => toastr.error('Failed to get request comments'),
            () => this.isCommentsLoading = false
        );
    }

    residentAccessController(action: ServiceRequestAction): boolean {
        if (!this.authenticationService.userIsResident) {
            return true;
        }

        switch (action) {
            case ServiceRequestAction.requestCreate:
                return this.residentService.serviceRequestSettings.residentPermission.serviceRequest.create;

            case ServiceRequestAction.requestAttachment:
                return this.residentService.serviceRequestSettings.residentPermission.serviceRequest.attachment;

            case ServiceRequestAction.commentRead:
                return this.residentService.serviceRequestSettings.residentPermission.comment.read;

            case ServiceRequestAction.commentCreate:
                return this.residentService.serviceRequestSettings.residentPermission.comment.create;

            case ServiceRequestAction.commentAttachment:
                return this.residentService.serviceRequestSettings.residentPermission.comment.attachment;

            default:
                return false;
        }
    }

    getPdf(serviceRequest) {
        const url = `/v1/service_request/${serviceRequest.id}/pdf`;
        return this.api.get('domainServiceRequest', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                window.open(body.pdf.path);
            }, error => toastr.error('Failed to get service request PDF.')
        );
    }

    getRequestTypesForDetailedView(buildingId): void {
        if (this.requestTypesForDetailedViewSubscription)
            this.requestTypesForDetailedViewSubscription.unsubscribe();
        this.requestTypesForDetailedView = [];
        const url = `/v1/settings/buildings/${buildingId}`;
        this.requestTypesForDetailedViewSubscription = this.api.get('domainServiceRequest', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                const types = (body.setting && body.setting.serviceRequestTypes) || [];
                this.requestTypesForDetailedView = types.map(type => ({id: type.id, name: type.name}));
                this.requestTypesForDetailedView.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get types')
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/service-request.service.ts